import FileUploadService from './service';

const ImageUploaderService = new FileUploadService();
export {ImageUploaderService};
